import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgPinFilled = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="#5B6770"
      fillRule="evenodd"
      d="m13.944 23.24 5.834-5.509c1.539-1.452 2.586-3.303 3.01-5.318a9.85 9.85 0 0 0-.625-6.001c-.833-1.898-2.243-3.52-4.052-4.662A11.467 11.467 0 0 0 12 0C9.824 0 7.698.61 5.889 1.75 4.079 2.892 2.67 4.514 1.837 6.412a9.85 9.85 0 0 0-.626 6.001c.425 2.015 1.472 3.866 3.01 5.318l5.836 5.51a2.837 2.837 0 0 0 1.944.759 2.83 2.83 0 0 0 1.943-.76Zm1.686-13.075c0 2.019-1.625 3.655-3.63 3.655s-3.63-1.636-3.63-3.655S9.995 6.51 12 6.51s3.63 1.636 3.63 3.655Z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgPinFilled);
export default ForwardRef;
